class SelectorDropdown {
    /*
    * constructor
    */
    constructor() {
        this.cacheDom();
        this.bindEvents();
    }

    cacheDom() {
        this.dataObj = [];
        this.elements = document.querySelectorAll('.c-selector__selected');
        this.selectOptions = document.querySelectorAll('.c-selector__option');

        /**
         * Templating
         */
        const faqItems = document.querySelector('#faq-items');
        const faqSupport = document.querySelector('#faq-support');
        this.faqSupportTemplate = _.template(faqSupport.innerHTML);
        this.faqListsTemplate = _.template(faqItems.innerHTML);
        this.faqRender = document.querySelector('.c-faqBlock__render');
        this.supportRender = document.querySelector('.c-downloads');
    }

    bindEvents() {
        if (_.isNull(this.elements) === false) {
            Array.prototype.forEach.call(this.elements, (el, i) => {
                el.addEventListener('click', () => {
                    if (el.parentNode.classList.contains('is-open')) {
                        el.parentNode.classList.remove('is-open');
                    } else {
                        el.parentNode.classList.add('is-open');
                    }
                });
            });
        }

        if (_.isNull(this.selectOptions) === false) {
            Array.prototype.forEach.call(this.selectOptions, (el, i) => {
                el.addEventListener('click', () => {

                    const value = el.getAttribute('data-value');
                    const textRegion = el.parentNode.parentNode.parentNode.querySelectorAll('.c-selector__selectedText');
                    const inputVal = el.parentNode.parentNode.parentNode.querySelectorAll('.c-selector__selectedInput');

                    textRegion[0].innerHTML = el.innerHTML;
                    inputVal[0].value = value; // el.innerHTML;
                    this.queryHandler(value, el.innerHTML);

                    if (el.parentNode.parentNode.parentNode.classList.contains('is-open')) {
                        el.parentNode.parentNode.parentNode.classList.remove('is-open');
                    }
                });

                this.clickFirstElement(el, i);
            });
        }
    }

    clickFirstElement(el, i) {
        if (i === 0) {
            el.click();
        }
    }

    queryHandler(id, name) {
        const dataObj = _.filter(this.dataObj, item => item.id === id);

        if (dataObj.length > 0) { 
            this.render(dataObj);
        } else {
            this.getData(id, name);
        }
    }

    getData(id, name) {
        axios.get('/wp-json/esper/api/v1/get-faqs', {
            params: {
                id,
                name,
            },
        }).then((response) => {
            if (response.data.success) {
                this.storeData(response);
                this.render(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    storeData(response) {
        this.dataObj.push({
            id: response.data.id,
            name: response.data.name,
            faqs: response.data.faqs,
            support: response.data.support,
        });
    }

    render(data) {
        this.faqRender.innerHTML = this.faqListsTemplate({ data });
        this.supportRender.innerHTML = this.faqSupportTemplate({ supports: data.support });
    }
}

module.exports = SelectorDropdown;